export const label = ({ theme: { colors }, opacity }) => ({
    fill: opacity < 0.25 ? colors.text : colors.white,
    fontSize: '6px',
    lineHeight: 1.56,
    letterSpacing: '0.2px',
});
